{
  "id": "tyr",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Tyr",
    "en": "Tyr"
  },
  "icon": "gods/tyr",
  "portrait": "gods/tyr-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "fenris-wolf-brood": 1
  },
  "unlocks": ["fenris-wolf-brood", "berserkergang", "bravery"],
  "powers": ["fimbulwinter"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Odin, Thor, Loki. Focus: infantry. Age tech MythicAgeTyr."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "MythicAgeTyr: CreateUnit fenris-wolf-brood quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
